import { FieldWrapper, FlexBox, FormField } from '@dixa/lib-shared-habla';
import { HookFormCheckbox } from 'lib-shared-hook-form';
import { ampli } from 'lib-shared-tracking';
import { Control } from 'react-hook-form';

import { HookFormQueuesSelect } from 'components/hookForm';

import type { FormValues } from '../composeEmailModal.types';

type ComposeEmailQueueSectionProps = {
  control: Control<FormValues>;
  queue: FormValues['queueId'];
};

export function ComposeEmailQueueSection({
  control,
  queue,
}: ComposeEmailQueueSectionProps): JSX.Element {
  return (
    <>
      <FormField span={4}>
        <HookFormQueuesSelect
          control={control}
          label="Queue"
          name="queueId"
          componentProps={{
            icon: 'flow',
            placeholder: 'Select a queue',
            clearable: true,
          }}
        />
      </FormField>

      <FormField span={2}>
        <FieldWrapper label="">
          <FlexBox alignItems="center" height="40px">
            <HookFormCheckbox
              control={control}
              label="Offer in queue"
              name="offerInQueue"
              componentProps={{
                disabled: queue?.length === 0,
                onChange: () =>
                  ampli.followUpConversationModalOfferInQueueAdded(),
              }}
              helpIcon={{
                requireClick: true,
                text: (
                  <>
                    <strong>If checked</strong>, the conversation will be
                    offered to agents in the selected queue.
                    <br />
                    <br />
                    <strong>If unchecked</strong>, the conversation will be
                    added to the queue in a closed state, and it will not be
                    offered to any agent.
                    <br />
                    <strong>If no queue is selected</strong>, offer in queue is
                    not available.
                  </>
                ),
              }}
            />
          </FlexBox>
        </FieldWrapper>
      </FormField>
    </>
  );
}
